import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index'
import IndexInfo from '../views/index-info/IndexInfo'
import OffshoreInfo from '../views/index-nav/OffshoreInfo'
import MapDetails from '../views/details/MapDetails'
import InfoDetails from '../views/details/InfoDetails'
import Strategy from '../views/strategy/Strategy'
import FishInfo from '../views/fish-info/FishInfo'
import InfoRelease from '../views/release/InfoRelease'
import UserInfo from '../views/user/UserInfo'
import MyPost from '../views/user/MyPost'
import PhoneDetails from '../views/details/PhoneDetails'
import Enterprise from '../views/enterprise/Enterprise'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            // name: 'Index',
            component: Index,
            children: [
                {
                    path: '/',
                    name: 'IndexInfo',
                    component: IndexInfo
                },
                {
                    path: '/OffshoreInfo',
                    name: 'OffshoreInfo',
                    component: OffshoreInfo
                },
                {
                    path: '/MapDetails',
                    name: 'MapDetails',
                    component: MapDetails
                },
                {
                    path: '/InfoDetails',
                    name: 'InfoDetails',
                    component: InfoDetails
                },
                {
                    path: '/Strategy',
                    name: 'Strategy',
                    component: Strategy
                },
                {
                    path: '/FishInfo',
                    name: 'FishInfo',
                    component: FishInfo
                },
                {
                    path: '/InfoRelease',
                    name: 'InfoRelease',
                    component: InfoRelease,
                    meta: {
                        Auth: false
                    }
                },
                {
                    path: '/UserInfo',
                    name: 'UserInfo',
                    component: UserInfo,
                    meta: {
                        Auth: true
                    }
                },
                {
                    path: '/MyPost',
                    name: 'MyPost',
                    component: MyPost,
                    meta: {
                        Auth: true
                    }
                },
                {
                    path: '/Enterprise',
                    name: 'Enterprise',
                    component: Enterprise,
                    meta: {
                        Auth: false
                    }
                }
            ]
        },
        {
            path: '/PhoneDetails',
            name: 'PhoneDetails',
            component: PhoneDetails
        }
    ]
})
router.beforeEach((to, from, next) => {
    // ...
    let vue = router.app
    let token = window.localStorage.getItem('token')
    window.scrollTo(0, 0)
    if (to.meta.Auth) {
        if (token) {
            next()
        } else {
            router.replace({path: '/'})
            vue.$message.error('请登录')
        }
    } else {
        next()
    }
    // async function asyncgGetUser(vue) {
    //     await vue.$store.dispatch('getUser')
    //     let token = vue.$store ? vue.$store.getters.getToken : ''
    //     if (to.meta.Auth) {
    //         if (token) {
    //             next()
    //         } else {
    //             router.replace({path: '/'})
    //             vue.$message.error('请登录')
    //         }
    //     } else {
    //         next()
    //     }
    // }
    // asyncgGetUser(vue)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js